//import React from "react";
import 
    React
    , {
        useEffect
    } from 'react';

import HeroLoreBuilding from "./HeroLoreBuilding";
import realSplitLogoUrl from '../../assets/images/logo/realspilt_logo_white.png';
import rsLogoUrl from '../../assets/images/logo/RS_icon_white.png';

/*
import StartInvestingToday from "./StartInvestingToday";
//import Selection from "./Selection";
import Popular from "./Popular";
//import HotBid from "../../components/HotBid";
//import Collections from "./Collections";
//import Discover from "./Discover";
//import Description from "./Description";
import RecentSold from './RecentSold/index';
//import Banner from "./Banner";
//import MetaLondas from "./MetaLodons";
//import Teams from "./Teams";
//import ContactUs from "./ContactUs";
import AuctionAssets from "./AuctionAssets";
*/

/*
Dark background image = "linear-gradient(180deg, rgba(212, 222, 236, 0.3) 0%, rgba(217, 217, 217, 0) 100%)" />
Light background image = "linear-gradient(180deg, #000000 0%, #2C466B 100%)" />
*/

const ItemLoreBuilding = () => {
    console.log('ItemLoreBuilding()');

    useEffect(() => {
        //document.getElementsByTagName('body')[0].classList.add('');
        //document.getElementsByTagName('body')[0].classList.remove('search');
        document.getElementsByTagName('body')[0].className = '';
    }, null);

    return (
        <>

        <div
            //style = {{
            //    backgroundColor: 'var(--color-theme-primary)'
                //backgroundColor: 'rgba(0,0,0,0.5)'
            //}}
            >

            <HeroLoreBuilding />

            {/*
            <div
                style = {{
                    display: 'flex'
                    , flexDirection: 'row'
                    , justifyContent: 'center'
                    , margin: 'auto'
                }}>

                <div>

                    <div
                        style = {{
                            display: 'table'
                            //, width: '100%'
                            //, maxWidth: '1000px'
                            //, margin: 'auto'
                            , paddingTop: '10px'
                        }}>

                        <div style = {{ display: 'table-cell' }}>
                            <img
                                src = { rsLogoUrl }
                                style = {{
                                    //width: '100px'
                                    height: '200px'
                                }}
                                />
                        </div>

                        <div
                            style = {{
                                color: '#fff'
                                , fontFamily: 'Times'
                                , fontSize: '30px'
                                , verticalAlign: 'top'
                                , display: 'table-cell'
                                , padding: '20px 0px 0px 20px'
                            }}
                            >
                            <img
                                src = { realSplitLogoUrl }
                                style = {{
                                    width: '150px'
                                    , verticalAlign: 'top'
                                }}
                                />
                            
                        </div>

                    </div>

                </div>

                <div>
                    <div
                        className = 'menu-container'
                        style = {{ display: 'flex' }}>
                        <div>about us</div>
                        <div>strategy</div> 
                        <div>portfolio</div> 
                        <div>log in</div> 
                    </div>
                </div>

            </div>
            */}

        </div>

        </>
    );
};

export default ItemLoreBuilding;
